import React from 'react';
import ComingSoonPage from '../components/ComingSoonPage';

export default function Faune() {
  return (
    <ComingSoonPage
      title={{
        fr: 'Observatoire faunique communautaire',
        en: 'Community wildlife observatory',
      }}
      sousTitre={{
        fr: 'Bientôt accessible aux membres',
        en: 'Coming soon to members',
      }}
      description={{
        fr: "Signalez vos observations d'espèces sauvages, gagnez des crédits convertibles en réductions sur vos locations, et contribuez à la cartographie collective de la faune québécoise et ontarienne.",
        en: 'Report your wildlife sightings, earn credits convertible into rental discounts, and contribute to the collective mapping of Quebec and Ontario wildlife.',
      }}
      cartes={[
        {
          icon: '🦌',
          title: { fr: 'Cartographie temps réel', en: 'Real-time mapping' },
          description: {
            fr: 'Observations validées et géolocalisées sur une carte interactive : cerf, orignal, ours, outardes, etc.',
            en: 'Geolocated validated observations on an interactive map: deer, moose, bear, geese, etc.',
          },
        },
        {
          icon: '🏆',
          title: { fr: 'Système de crédits', en: 'Credit system' },
          description: {
            fr: 'Chaque observation validée par un admin vous fait gagner des crédits convertibles en réductions sur vos locations de terres.',
            en: 'Each observation validated by an admin earns you credits convertible into discounts on your land rentals.',
          },
        },
        {
          icon: '🤝',
          title: { fr: 'Partage avec les autorités', en: 'Authority sharing' },
          description: {
            fr: 'Données partagées avec MELCCFP (QC) et MNRF (ON) pour soutenir la gestion fauniques.',
            en: 'Data shared with MELCCFP (QC) and MNRF (ON) to support wildlife management.',
          },
        },
      ]}
      liensExtras={[
        {
          label: {
            fr: 'Voir les terres et les zones de chasse',
            en: 'View lands and hunting zones',
          },
          link: '/lands',
        },
      ]}
      cta={{
        label: { fr: 'Soumettre une observation (bientôt)', en: 'Submit an observation (soon)' },
        link: '/signup',
        disabled: true,
      }}
    />
  );
}
